/* BookLove Shopify theme — front-end interactions
   (ported from the static site's components.js, adapted for Shopify variants) */
document.addEventListener("DOMContentLoaded", function () {
  // ---- Mobile nav ----
  var toggle = document.querySelector(".nav-toggle");
  if (toggle) {
    toggle.addEventListener("click", function () {
      var open = document.body.classList.toggle("nav-open");
      toggle.setAttribute("aria-expanded", String(open));
    });
  }

  // ---- PDP gallery thumbnails ----
  var main = document.querySelector(".pdp-main img");
  if (main) {
    document.querySelectorAll(".pdp-thumbs img").forEach(function (th) {
      th.addEventListener("click", function () {
        document.querySelectorAll(".pdp-thumbs img").forEach(function (t) { t.classList.remove("is-active"); });
        th.classList.add("is-active");
        main.src = th.getAttribute("data-full") || th.src;
      });
    });
  }

  // ---- Quantity steppers (input-based; works on PDP + cart) ----
  document.querySelectorAll(".stepper").forEach(function (st) {
    var input = st.querySelector('input[type="number"], .qty-input');
    if (!input) return;
    st.querySelectorAll("button[data-dir]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        var n = parseInt(input.value, 10) || 1;
        n = b.dataset.dir === "down" ? Math.max(parseInt(input.min, 10) || 1, n - 1) : n + 1;
        input.value = n;
      });
    });
  });

  // ---- FAQ / accordion ----
  document.querySelectorAll(".faq-q").forEach(function (q) {
    q.addEventListener("click", function () {
      var item = q.closest(".faq-item");
      var a = item.querySelector(".faq-a");
      var open = item.classList.toggle("open");
      if (a) a.style.maxHeight = open ? a.scrollHeight + 40 + "px" : "0px";
    });
  });

  // ---- Technical-service tabs (Customer Care) ----
  var tsTabs = document.querySelectorAll(".ts-tab");
  tsTabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      var target = tab.dataset.tab;
      tsTabs.forEach(function (t) { t.classList.toggle("is-active", t === tab); });
      document.querySelectorAll(".ts-panel").forEach(function (p) {
        p.classList.toggle("is-active", p.dataset.panel === target);
      });
    });
  });

  // ---- Product variant selection (chips → hidden id + price + availability) ----
  document.querySelectorAll("form.product-form").forEach(function (form) {
    var dataEl = form.querySelector("[data-variants]");
    var pricesEl = form.querySelector("[data-variant-prices]");
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var prices = pricesEl ? JSON.parse(pricesEl.textContent) : {};
    var idInput = form.querySelector('input[name="id"]');
    var priceOut = form.querySelector("[data-price-output]");
    var addBtn = form.querySelector("[data-add]");
    var selected = {};

    form.querySelectorAll("[data-option-position]").forEach(function (group) {
      var pos = group.getAttribute("data-option-position");
      var active = group.querySelector(".is-active");
      if (active) selected[pos] = active.getAttribute("data-value");
      group.querySelectorAll("[data-value]").forEach(function (opt) {
        opt.addEventListener("click", function (e) {
          e.preventDefault();
          group.querySelectorAll("[data-value]").forEach(function (o) { o.classList.remove("is-active"); });
          opt.classList.add("is-active");
          selected[pos] = opt.getAttribute("data-value");
          update();
        });
      });
    });

    function update() {
      var match = variants.find(function (v) {
        return Object.keys(selected).every(function (pos) { return v["option" + pos] === selected[pos]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceOut && prices[match.id]) priceOut.innerHTML = prices[match.id];
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (addBtn.dataset.label || "Add to bag") : "Sold out";
      }
    }
    update();
  });

  // ---- Testimonial carousel (arrows + dots switch active card) ----
  document.querySelectorAll(".tst").forEach(function (tst) {
    var cards = tst.querySelectorAll(".tst-card");
    var dots = tst.querySelectorAll(".dots button");
    var arrows = tst.querySelectorAll(".tst-arrow");
    if (cards.length <= 1) return;
    var idx = Array.prototype.findIndex.call(cards, function (c) { return c.classList.contains("is-active"); });
    if (idx < 0) idx = 0;
    function show(n) {
      idx = (n + cards.length) % cards.length;
      cards.forEach(function (c, k) { c.classList.toggle("is-active", k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === idx); });
    }
    if (arrows[0]) arrows[0].addEventListener("click", function () { show(idx - 1); });
    if (arrows[1]) arrows[1].addEventListener("click", function () { show(idx + 1); });
    dots.forEach(function (d, k) { d.addEventListener("click", function () { show(k); }); });
    show(idx);
  });

  // ---- Shop category filter (chips filter the product grid client-side) ----
  document.querySelectorAll(".shop-filters").forEach(function (bar) {
    var chips = bar.querySelectorAll(".filter-chip");
    var cards = document.querySelectorAll(".product-grid .pcard");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("is-active"); });
        chip.classList.add("is-active");
        var cat = chip.dataset.cat;
        cards.forEach(function (card) {
          card.style.display = (cat === "all" || card.dataset.cat === cat) ? "" : "none";
        });
      });
    });
  });

  // ---- Shop "buy" cards: option select + qty + AJAX add-to-cart ----
  document.querySelectorAll("[data-product-card]").forEach(function (card) {
    var dataEl = card.querySelector("[data-variants]");
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var pricesEl = card.querySelector("[data-variant-prices]");
    var prices = pricesEl ? JSON.parse(pricesEl.textContent) : {};
    var imagesEl = card.querySelector("[data-variant-images]");
    var variantImages = imagesEl ? JSON.parse(imagesEl.textContent) : {};
    var idInput = card.querySelector("[data-variant-id]");
    var priceOut = card.querySelector("[data-price-output]");
    var qv = card.querySelector(".qty-val");
    var selected = {};

    card.querySelectorAll("[data-option-position]").forEach(function (group) {
      var pos = group.getAttribute("data-option-position");
      var active = group.querySelector(".is-active");
      if (active) selected[pos] = active.getAttribute("data-value");
      group.querySelectorAll("[data-value]").forEach(function (opt) {
        opt.addEventListener("click", function () {
          group.querySelectorAll("[data-value]").forEach(function (o) { o.classList.remove("is-active"); });
          opt.classList.add("is-active");
          selected[pos] = opt.getAttribute("data-value");
          sync();
        });
      });
    });
    function sync() {
      var m = variants.find(function (v) {
        return Object.keys(selected).every(function (p) { return v["option" + p] === selected[p]; });
      });
      if (!m) return;
      if (idInput) idInput.value = m.id;
      if (priceOut && prices[m.id]) priceOut.innerHTML = prices[m.id];
      if (variantImages[m.id]) {
        // shop card: image lives inside the card; PDP: image is the sibling .pdp-main
        var imgEl = card.querySelector(".pcard-media img");
        if (!imgEl) {
          var pdp = card.closest(".pdp");
          imgEl = pdp ? pdp.querySelector(".pdp-main img") : document.querySelector(".pdp-main img");
        }
        if (imgEl) imgEl.src = variantImages[m.id];
        document.querySelectorAll(".pdp-thumbs img").forEach(function (t) {
          t.classList.toggle("is-active", (t.getAttribute("data-full") || t.src) === variantImages[m.id]);
        });
      }
    }
    if (qv) {
      card.querySelectorAll(".qty button[data-dir]").forEach(function (b) {
        b.addEventListener("click", function () {
          var n = parseInt(qv.textContent, 10) || 1;
          n = b.dataset.dir === "down" ? Math.max(1, n - 1) : n + 1;
          qv.textContent = n;
        });
      });
    }
    var addBtn = card.querySelector("[data-add-to-cart]");
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var id = idInput ? idInput.value : null;
        if (!id) return;
        var qty = parseInt(qv ? qv.textContent : "1", 10) || 1;
        addBtn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: id, quantity: qty })
        })
          .then(function () { return fetch("/cart.js"); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            renderBag(cart);
            showBag();
            addBtn.classList.add("is-fav");
            addBtn.disabled = false;
          })
          .catch(function () { addBtn.disabled = false; });
      });
    }
    sync();
  });

  // ---- Cart drawer (bag icon and add-to-cart both open it) ----
  var bagOverlay = document.getElementById("bag-overlay");
  var bagDrawer = document.getElementById("bag-drawer");
  function blMoney(cents) {
    return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function renderBag(cart) {
    document.querySelectorAll(".cart-badge").forEach(function (b) { b.textContent = cart.item_count; });
    if (!bagDrawer) return;
    var cnt = bagDrawer.querySelector(".bag-title-count"); if (cnt) cnt.textContent = cart.item_count;
    var sub = bagDrawer.querySelector(".bag-subtotal-val"); if (sub) sub.textContent = blMoney(cart.total_price);
    var list = bagDrawer.querySelector(".bag-items"); if (!list) return;
    if (!cart.items || cart.items.length === 0) { list.innerHTML = '<p class="bag-empty">Your bag is empty.</p>'; return; }
    list.innerHTML = cart.items.map(function (i) {
      var vt = (i.variant_title && i.variant_title !== "Default Title") ? '<span class="bag-item-model">' + i.variant_title + "</span>" : "";
      return '<div class="bag-item"><img src="' + (i.image || "") + '" alt="">' +
        '<div class="bag-item-info"><a href="' + i.url + '">' + i.product_title + "</a>" + vt +
        '<span class="bag-item-qty">Qty: ' + i.quantity + "</span></div>" +
        '<div class="bag-item-right"><span class="bag-item-price">' + blMoney(i.final_line_price) + "</span>" +
        '<button class="bag-remove" data-key="' + i.key + '" aria-label="Remove">&times;</button></div></div>';
    }).join("");
  }
  function fetchBag(cb) { fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { renderBag(c); if (cb) cb(c); }); }
  function showBag() { if (bagOverlay) bagOverlay.classList.add("open"); if (bagDrawer) { bagDrawer.classList.add("open"); bagDrawer.setAttribute("aria-hidden", "false"); } document.body.classList.add("bag-open"); }
  function openBag() { fetchBag(); showBag(); }
  function closeBag() { if (bagOverlay) bagOverlay.classList.remove("open"); if (bagDrawer) { bagDrawer.classList.remove("open"); bagDrawer.setAttribute("aria-hidden", "true"); } document.body.classList.remove("bag-open"); }
  document.querySelectorAll("[data-cart-toggle]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openBag(); }); });
  if (bagDrawer) {
    var bc = bagDrawer.querySelector(".bag-close"); if (bc) bc.addEventListener("click", closeBag);
    var bagItems = bagDrawer.querySelector(".bag-items");
    if (bagItems) bagItems.addEventListener("click", function (e) {
      var rm = e.target.closest(".bag-remove"); if (!rm) return;
      fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: rm.getAttribute("data-key"), quantity: 0 }) })
        .then(function (r) { return r.json(); }).then(renderBag);
    });
    var ck = bagDrawer.querySelector(".bag-checkout"); if (ck) ck.addEventListener("click", function () { window.location.href = "/checkout"; });
  }
  if (bagOverlay) bagOverlay.addEventListener("click", closeBag);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeBag(); });
  fetchBag();
});
